import { render, staticRenderFns } from "./ShowUserCard.vue?vue&type=template&id=93115fba&scoped=true"
import script from "./ShowUserCard.vue?vue&type=script&lang=js"
export * from "./ShowUserCard.vue?vue&type=script&lang=js"
import style0 from "./ShowUserCard.vue?vue&type=style&index=0&id=93115fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93115fba",
  null
  
)

export default component.exports